import {Component, computed, input} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {
  Address,
  Campaign,
  CampaignCardPromoDetailsComponent,
  CampaignUserStatus,
  getCampaignLocationDisplayString,
  LoyaltyNumberPipe,
  openMapApp,
  Size,
  TimeConditionsType, LoyaltyRadialBarComponent,
  CampaignCardSentenceMerchantComponent
} from 'shared-lib';
import {TranslocoDirective} from '@jsverse/transloco';
import {
  HowToRedeemData,
  HowToRedeemDirectionsComponent
} from '../../how-to-redeem-directions/how-to-redeem-directions.component';
import {
  LoyaltyCampaignCardPromoDetailsComponent
} from './loyalty-campaign-card-promo-details/loyalty-campaign-card-promo-details.component';

@Component({
  selector: 'app-map-marker-details-card',
  templateUrl: './map-marker-details-card.component.html',
  styleUrl: './map-marker-details-card.component.scss',
  imports: [TranslocoDirective, CampaignCardPromoDetailsComponent, LoyaltyNumberPipe, LoyaltyRadialBarComponent,
    LoyaltyCampaignCardPromoDetailsComponent, CampaignCardSentenceMerchantComponent]
})
export class MapMarkerDetailsCardComponent {

  campaign = input.required<Campaign>();
  address = input.required<Address>()
  campaignUserStatus = input.required<CampaignUserStatus>();

  locationDisplayString = computed<string | undefined>(() => {
    return getCampaignLocationDisplayString(this.campaign());
  });

  protected readonly TimeConditionsType = TimeConditionsType;
  protected readonly CampaignUserStatus = CampaignUserStatus;
  protected readonly location = location;
  protected readonly openMapApp = openMapApp;
  protected readonly Size = Size;

  constructor(private bottomSheet: MatBottomSheet) {
  }

  openHowToRedeem(): void {
    const howToRedeemData: HowToRedeemData = {
      rewardAmount: this.campaign().reward,
      merchantName: this.campaign().merchant?.name || '',
      fullAddress: this.locationDisplayString(),
      latitude: this.address().latitude,
      longitude: this.address().longitude,
    };

    this.bottomSheet.open(HowToRedeemDirectionsComponent, {
      data: {...howToRedeemData},
    });
  }
}
